import { Div, Link, Paragraph, Span } from "@tblabs/truffle";
import { HtmlArticle } from "../../../Components/Product/Card";
import { Product } from "../../../Models/Product/Product";
import { ProductCardFigure } from "../../../Components/Product/CardFigure";
import { ProductRating } from "../../Product/Components/ProductRating";
import { Svg } from "../../Components/Utils/Svg";
import { Icons } from "../../../Components/Utils/Icons";


export class ProductBox extends HtmlArticle
{
    constructor(product: Product)
    {
        super("product-card group");

        this.OnClick(() => window.location.hash = `produkt/${product.Url.value}`)

        const pricePerDay = product.GetPriceAsText();

        this.Append(
            new Link("", product.Url.value).Class("product-card__link")
                .Append(
                    new ProductCardFigure(product.Images.First()?.ThumbnailUrl.value ?? ""),
                    new ProductRating(product).PositionAbsolute().Top(0).Right(8),
                    new Div("product-card__content").Append(
                        new Div("product-card__title")
                            .Id(`product-${product.Title.value.toLowerCase()}`)
                            .Text(product.Title.value),
                        new Paragraph("product-card__description").Text(product.Subtitle.value),
                        new Div("product-card__footer" + (pricePerDay != "" ? "" : " justify-right"))
                            .Append(
                                pricePerDay != "" && new Paragraph("product-card__price").Text(pricePerDay),
                                new Div("product-card__button")
                                    .Attribute("aria-hidden", "true")
                                    .Append(
                                        new Span("Zobacz więcej"),
                                        new Svg(Icons.ArrowRight),
                                    )
                            ), // product-card__footer
                    ), // product-card__content
                )
        );
    }
}
